<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const page = usePage()
const brand = computed(() => page.props.brand || {})
</script>

<template>
  <div class="min-h-screen bg-[color:var(--bg)] flex flex-col">
    <header class="px-4 py-3 border-b border-[color:var(--line)] bg-[color:var(--surface)]">
      <div class="max-w-md mx-auto flex items-center gap-3">
        <img v-if="brand.logo_url"
             :src="brand.logo_url"
             :alt="brand.business_name || ''"
             class="h-8 w-8 object-contain rounded-[var(--radius-md)]">
        <span class="font-display text-base text-[color:var(--ink)]">
          {{ brand.business_name || 'Rental CRM' }}
        </span>
      </div>
    </header>

    <main class="flex-1 px-4 py-6">
      <div class="max-w-md mx-auto w-full"
           :style="{ paddingBottom: 'max(env(safe-area-inset-bottom), 1rem)' }">
        <slot />
      </div>
    </main>
  </div>
</template>
